import revereLogo from '../images/inflo-logo-reverse.svg'; //  '../../images/inflo_logo_24.svg';
import heroImage from '../images/runningmanHeroV2-blue.jpg';

let config = {
  basename: process.env.REACT_APP_BASENAME || '',
  gaTrackingID: process.env.REACT_APP_GA_TRACKING_ID,
  serverURL: process.env.REACT_APP_SERVER_URL,
  unknownSeason: 999,
  minLengthOfSentence: 100,
  maxLengthOfSentence: 580
};

export default Object.freeze(Object.assign({}, config));

export const PRIVACY_URL = 'https://education.ex-iq.com/privacy/';
export const AGREEMENT_URL = 'https://education.ex-iq.com/user-agreement/';

export const RESERVED_TAGS = {
  AI: 'AI:',
  MY_AUDIO_FEEDBACK: 'MyAudioFeedback',
  UNTAGGED: 'Untagged',
  UPTAG: 'UPTAG',
  DOWNTAG: 'DOWNTAG',
  FLASH: 'FLASH',
  RETRIEVAL: 'Retrieval-'
};

export const RETRIEVAL_DICTATION_SEPARATOR = '\\[AI feedback\\]';

export const MAX_SIZE_OPML = 2097152; // bytes
export const MAX_SIZE_PDF = 10485760; // bytes

export const NONE = 'none';

export const CONSTANTS = {
  heroImage,
  showEXIQ: false,
  swalLogo: revereLogo
};

export const initialFlagFilters = {
  pageStart: null,
  documentUrl: '',
  podcastUrl: '',
  tags: [],
  users: [],
  isMine: true,
  isShared: true,
  isAiFlags: false
};

export const USER_STATUS = {
  NEW: 'new',
  FREE: 'free',
  SUBSCRIBED: 'subscribed',
  INACTIVE: 'inactive'
};

export const STARTING_PODCASTS_PAGE_SIZE: number = 500; //50
export const PODCASTS_PAGE_SIZE: number = 500; //10

export const DOCUMENTS_PAGE_SIZE: number = 50;

export const ALLOWED_ORIGINS: string[] = [
  'http://localhost:3000',
  'https://develop.goinflo.com',
  'https://staging.goinflo.com',
  'https://portal.goinflo.com'
];

export const MOBILE_MAX_WIDTH = 1100;
